export default __webpack_public_path__ + "static/facebook-094947542ac8ae3180aa97f21677572a.png";